import React from "react";

import { ReactComponent as ReactLoaderSvg } from "../../../../icons/loader.svg";

const CircularLoader = ({ children, ...props }) => {
  return <ReactLoaderSvg style={{ width: "40px" }} />;
};

export default CircularLoader;
